export default __webpack_public_path__ + "static/2021 StM Annual School Report-f86c692dc5f9e162d9c1fad32d1f1a4b.pdf";